"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.box"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _knotchincWebReactComponents3 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.fade-in"));

var _reactDom = require("react-dom");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TooltipPortal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TooltipPortal, _React$PureComponent);

  var _super = _createSuper(TooltipPortal);

  function TooltipPortal(props) {
    var _this;

    _classCallCheck(this, TooltipPortal);

    _this = _super.call(this, props);
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(TooltipPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _reactDom.createPortal)(this.props.children, this.el);
    }
  }]);

  return TooltipPortal;
}(_react["default"].PureComponent);

var Tooltip = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(Tooltip, _React$PureComponent2);

  var _super2 = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this2;

    _classCallCheck(this, Tooltip);

    _this2 = _super2.call(this, props);
    _this2.state = {
      visible: false
    };
    _this2.width = props.width || 240;
    _this2.space = props.space || 16;
    _this2.showTooltip = _this2.showTooltip.bind(_assertThisInitialized(_this2));
    _this2.hideTooltip = _this2.hideTooltip.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(Tooltip, [{
    key: "showTooltip",
    value: function showTooltip() {
      // some maths to align the tooltip with whatever you just hovered over (the 'target')
      // or maybe it's 'math' in your weird country
      var style = {
        width: this.width
      }; // this style object will be passed as the tooltip's 'style' prop

      var dimensions = this.el.getBoundingClientRect(); // where on the screen is the target
      // center align the tooltip by taking both the target and tooltip widths into account

      style.left = dimensions.left + this.space;
      style.left = Math.max(this.space, style.left); // make sure it doesn't poke off the left side of the page

      style.left = Math.min(style.left, document.body.clientWidth - this.width - this.space); // or off the right

      style.top = dimensions.top + dimensions.height + this.space;
      this.setState({
        visible: true,
        style: style
      });
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var info = this.props.info;
      if (!info) return null;
      return /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"] // a span so it's valid HTML no matter where it's used
      , {
        onMouseOver: this.showTooltip,
        onMouseOut: this.hideTooltip,
        className: "tooltip-trigger-text",
        ref: function ref(el) {
          return _this3.el = el;
        },
        display: "inline-block",
        verticalAlign: "middle"
      }, this.props.children, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents3["default"], null, this.state.visible && /*#__PURE__*/_react["default"].createElement(TooltipPortal, null, /*#__PURE__*/_react["default"].createElement(_styled.ToolTipBody // this <div> isn't actually a child of the <span> above. Magic portal.
      , {
        className: "tooltip-body",
        style: this.state.style
      }, info.title && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
        color: "#F8377B",
        marginBottom: "16px",
        letterSpacing: "1.5px",
        fontWeight: "bold",
        fontSize: "10px"
      }, info.title.toUpperCase()), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
        color: "#858585",
        lineHeight: "17px"
      }, info.text), info.secondaryText && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
        marginTop: "16px",
        color: "#858585",
        lineHeight: "17px"
      }, info.secondaryText)))));
    }
  }]);

  return Tooltip;
}(_react["default"].PureComponent);

var _default = Tooltip;
exports["default"] = _default;

//# sourceMappingURL=Tooltip.js.map